/**
 * Centralized Configuration for CISO Advisor
 * 
 * All environment-specific settings are defined here.
 * Uses environment variables with sensible defaults.
 */

const config = {
  // API Configuration
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  
  // Environment
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  
  // Feature Flags (can be expanded)
  features: {
    gapAnalysis: true,
    aiRecommendations: true,
  },
  
  // App Metadata
  appName: 'CISO Advisor',
  version: '1.0.0',
};

// Validation - warn if critical configs are missing
if (!config.apiUrl) {
  console.warn('⚠️ REACT_APP_API_URL not set, using default:', config.apiUrl);
}

export default config;
